import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { cn } from '../../../utils/cn';

export const tableLegendClassNames = {
  root: 'Chart-TableLegend',
} as const;

export type TableLegendRootProps = BoxProps<'ul'>;

export const TableLegendRoot = ({ children, sx, className, ...props }: TableLegendRootProps) => (
  <Box
    component="ul"
    aria-label="Chart legend"
    className={cn(tableLegendClassNames.root, className)}
    sx={[
      {
        display: 'grid',
        gridTemplateColumns: '1fr max-content max-content',
        overflow: 'auto',
        columnGap: 3,
        rowGap: 0,
        alignContent: 'safe center',
        padding: 0,
        margin: 0,
        width: '100%',
        height: '100%',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}>
    {children}
  </Box>
);
